import jspdf from 'jspdf'
import { autoTable } from 'jspdf-autotable'

const getStatusColor = (status: string) => {
  const items = {
    'Fully Paid': {
      bg: 'fullyPaidBg',
      text: 'fullyPaidText',
    },
    Departed: {
      bg: 'primaryLight',
      text: 'primary',
    },
    Scheduled: {
      bg: 'success50',
      text: 'success100',
    },
    Cancelled: {
      text: 'red500',
      bg: 'red50',
    },
    Rejected: {
      text: 'red500',
      bg: 'red50',
    },
    Pending: {
      text: 'primary',
      bg: 'primaryLight',
    },
    Confirmed: {
      bg: 'success50',
      text: 'success100',
    },
    Approved: {
      bg: 'success50',
      text: 'success100',
    },
    Paid: {
      bg: 'fullyPaidBg',
      text: 'fullyPaidText',
    },
    Other: { text: 'white', bg: 'text' },
  }
  return items[status] || items['Other']
}

const getUser = () => {
  try {
    const raw =
      typeof window !== 'undefined'
        ? sessionStorage.getItem('meroseat-user')
        : null
    if (!raw) return null
    const parsed = JSON.parse(raw)
    // Basic shape check to avoid prototype pollution or unexpected objects
    if (parsed && typeof parsed === 'object') {
      return parsed
    }
    return null
  } catch (_) {
    // Corrupt or tampered storage; clear and treat as logged out
    try {
      sessionStorage.removeItem('meroseat-user')
    } catch (_) {}
    return null
  }
}

const removeUser = () => {
  try {
    return sessionStorage.removeItem('meroseat-user')
  } catch (_) {
    return null
  }
}

const saveUser = (data: any) => {
  try {
    // Store only expected primitives/objects to reduce risk of accidental large/PII dumps
    return sessionStorage.setItem('meroseat-user', JSON.stringify(data))
  } catch (_) {
    return null
  }
}

const toCamelCase = (str: string) => {
  return str
    .toLowerCase()
    .replace(/(?:^\w|[A-Z]|\b\w)/g, (word, index) =>
      index === 0 ? word.toLowerCase() : word.toUpperCase(),
    )
    .replace(/\s+/g, '')
}

const COLORS = [
  '#007bff',
  '#6f42c1',
  '#e83e8c',
  '#fd7e14',
  '#20c997',
  '#17a2b8',
]

const getDynamicColor = (input: string) => {
  let hash = 0
  for (let i = 0; i < input.length; i++) {
    hash = input.charCodeAt(i) + ((hash << 5) - hash)
  }
  const index = Math.abs(hash) % COLORS.length
  return COLORS[index]
}

const formatDate = (dateString) => {
  const date = new Date(dateString)
  const options: any = { month: 'short', day: 'numeric', year: 'numeric' }
  return date.toLocaleDateString('en-US', options)
}

// Format time function
const formatTime = (dateString) => {
  const date = new Date(dateString)
  return date
    .toLocaleTimeString('en-US', {
      hour: '2-digit',
      minute: '2-digit',
      hour12: true,
    })
    .toLowerCase()
}
const downloadPDF = (head, body, title) => {
  const doc = new jspdf()
  autoTable(doc, {
    head: [head],
    body: body,
    styles: { fontSize: 4, cellPadding: 2 },
    headStyles: { fillColor: '#2770bc', fontSize: 4, fontStyle: 'normal' },
    theme: 'grid',
  })
  doc.save(title)
}
export default {
  getStatusColor,
  getUser,
  removeUser,
  saveUser,
  toCamelCase,
  getDynamicColor,
  formatDate,
  formatTime,
  downloadPDF,
}
